import { Request } from '../../Servidor/Request';

export class MigrationRequest {
    private teste: number;
    private nome: string;

    constructor(teste: number, nome: string) {
        this.teste = teste;
        this.nome = nome;
    }


    /**
     * Getter teste
     * @return {number}
     */
    public getSgepdengueespecie(): number {
        return this.teste;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }

}

export class MigrationStructRequest {
    private teste: number;

    constructor(teste: number) {
        this.teste = teste;
    }


    /**
     * Getter teste
     * @return {number}
     */
    public getSgepdengueespecie(): number {
        return this.teste;
    }

}

export class MigrationStructResponse {
    private teste: number;
    private nome: string;

    constructor(teste: number, nome: string) {
        this.teste = teste;
        this.nome = nome;
    }


    /**
     * Getter teste
     * @return {number}
     */
    public getSgepdengueespecie(): number {
        return this.teste;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class MigrationInteractor {
    public getMigrations(page: number): PromiseLike<MigrationStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/migrations/listar", { page }).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}